import { Link } from "react-router-dom";
import { BottleImg } from "../BottleImg";
import { figureInfo } from "../../content/articleImages";

export const ArticleFigure = ({ media, testId, eager = false }) => {
  const f = figureInfo(media);
  return (
    <figure className="my-8" data-testid={testId}>
      {f.product ? (
        <Link to={`/products/${f.product}`} className="block photo-panel p-6 flex justify-center" aria-label={`View ${f.name}`}>
          <BottleImg src={f.src} alt={f.alt} width="240" height="320" loading={eager ? "eager" : "lazy"} sizes="(max-width: 640px) 60vw, 300px" className="h-72 w-auto object-contain" />
        </Link>
      ) : (
        <picture>
          <source srcSet={f.srcSmall} type="image/webp" />
          <img src={f.src} alt={f.alt} width={f.width} height={f.height} loading={eager ? "eager" : "lazy"} {...(eager ? { fetchpriority: "high" } : {})} className="w-full max-h-[480px] object-cover border border-[#EBD9D0]" />
        </picture>
      )}
      <figcaption className="text-xs text-[#171715]/60 mt-2 leading-relaxed">
        {f.caption}
        {f.product && <> <Link to={`/products/${f.product}`} className="underline text-[#A35847]">View {f.name} →</Link></>}
      </figcaption>
    </figure>
  );
};
